import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=3fd69d48&"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js&"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports